import { useQuery } from '@tanstack/react-query'
import { accountKeys, guestKeys } from '../../../../data/queryFactories'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
import { accountService } from '../../../../service/AccountService'
import { convertUnixToDate } from '../../../../utils/conversion'

function mapUserData(data) {
  return {
    uuid: data.uuid || null,
    id: data.schoolId || null,
    name: data.fullName || null,
    accountType: data.accountType || null,
    course: data.studentCourse || null,
    groups: (data?.groups ?? []).map((item) => {
      return {
        uuid: item.uuid,
        name: item.name,
      }
    }),
    schoolEmail: data.schoolEmail || null,
    personalEmail: data.personalEmail || null,
    phoneNumber: data.phoneNumber || null,
    className: data.className || null,
    faculty: data.faculty || null,
    school: data.school || null,
    devices: data?.devices ?? [],
    books: data?.books ?? [],
    status: data.status || null,
    totalPayment: data.totalPayment || 0,
    joinDate: convertUnixToDate(data.joinDate),
  }
}

export default function useGetGuestAccountById(uuid) {
  const { data, isLoading, error } = useQuery({
    queryKey: guestKeys.detail(uuid),
    queryFn: async () => {
      showLoadingToast('Đang tải', toastKey.ACCOUNT.GUEST.DETAIL)

      const { success, message } = await accountService.getByUuid(uuid)

      if (!success) {
        throw new Error('Lỗi: Không thể lấy dữ liệu người dùng')
      }

      const userData = message?.content
      if (userData) {
        showSuccessToast(
          'Tải tài khoản thành công',
          toastKey.ACCOUNT.GUEST.DETAIL
        )

        return mapUserData(userData)
      }

      throw new Error('Không tìm thấy thông tin người dùng')
    },
  })

  if (error) {
    showErrorToast({
      error: error.message,
      message: 'Lấy thông tin thất bại vui lòng liên hệ admin',
      toastId: toastKey.ACCOUNT.GUEST.DETAIL,
    })
  }

  return { data, isLoading, error }
}
